import { getI18n, useTranslation } from "react-i18next";
import source from "./locales/en/notificationContent";
import { renderNotificationExpression, validNotificationExpression, type NotificationExpression, type NotificationPresentation } from "../../../../src/lib/contracts/notificationPresentation";
export type { NotificationExpression, NotificationPresentation } from "../../../../src/lib/contracts/notificationPresentation";
export function useNotificationContentLanguage(): string { const { i18n } = useTranslation(); return i18n.resolvedLanguage ?? i18n.language ?? "en"; }
/** Resolve at render time; raw rows remain the source for sorting, searches and requests. */
export function notificationContentText(fallback: string, descriptor: unknown): string {
  if (!validNotificationExpression(descriptor, source)) return fallback;
  const engine = getI18n();
  const locale = engine?.resolvedLanguage ?? engine?.language ?? "en";
  const catalog: Record<string, string> = engine?.isInitialized ? engine.getResourceBundle(locale, "notificationContent") ?? source : source;
  try { return renderNotificationExpression(descriptor, source, catalog, locale) ?? fallback; }
  catch { return fallback; }
}
export function notificationFieldText(item: { title?: string | null; body?: string | null; actionLabel?: string | null; presentation?: NotificationPresentation }, field: "title" | "body" | "actionLabel"): string {
  const fallback = item[field] ?? "";
  const descriptor = item.presentation?.version === 1 ? item.presentation.fields?.[field] : undefined;
  if (!descriptor || typeof descriptor.fallbackHash !== "string" || !/^[a-f0-9]{64}$/.test(descriptor.fallbackHash)) return fallback;
  return notificationContentText(fallback, descriptor);
}
